import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// if the user is logged in redirect to '/' so cant see the other pages
// like sign up and log in
const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        localStorage.getItem('isLogged') && restricted ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
